import { render, staticRenderFns } from "./PackSection.vue?vue&type=template&id=541f7871&scoped=true"
import script from "./PackSection.vue?vue&type=script&lang=js"
export * from "./PackSection.vue?vue&type=script&lang=js"
import style0 from "./PackSection.vue?vue&type=style&index=0&id=541f7871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f7871",
  null
  
)

export default component.exports